<template>
    <div v-if="product != null">

        <table class="table table-sm table-borderless mb-0" style="line-height: 2;margin-top:-3px;"> <!--    margin-top:-30px;-->
            <tbody>
                <tr class="mx-0 px-0"><!--   HEAVY_PACKAGE: 16777216     //25 -->                  
                    <td class="mx-0 px-0"><div class="mx-0 px-0">Schwerer Karton</div></td> <!-- needs to set flag -->
                    <td><input class="my-auto mx-2" type="checkbox" value="1" v-model="isHeavyPackage" @change="chkHeavyPackage()"></td>
                </tr><!-- HEAVY_PACKAGE -->
                <tr v-bind:style="{ color: (product.shippingWeightType != SHIPPING_WEIGHT_TYPE_MARKET ? 'lightgray' : '') }">
                    <td class="px-0">Marktplatz Gewicht</td>
                    <td>{{ product.marketWeight }} g</td>
                    <td rowspan="2">
                        <div class="d-flex justify-content-end">
                            <div @click="btnFsk()" style="margin-top:-10px; margin-left:10px;"> <!--style="margin-top:-48px;"-->
                                <img v-if="(product.flags & FSK_18) == FSK_18" src="/images/FSK18_small.png" alt="[FSK 18]" width=64 height=64 title="FSK 18-Markierung entfernen" style="cursor: pointer;"/>
                                <img v-else src="/images/FSK18_small.png" class="img-responsive center-block" alt="[FSK 18]" width=64 height=64 style="-webkit-filter: grayscale(1); cursor: pointer;" title="FSK 18-Markierung setzen"/>
                            </div>

                            <div @click="btnLithium()" style="margin-top:-10px; margin-left:10px;"> <!--style="margin-top:-48px;"-->
                                <img v-if="(product.flags & LITHIUM_BATTERY) == LITHIUM_BATTERY" src="/images/battery_red.png" alt="Batterie" width=64 height=64 title="Lithium Batterie verbieten" style="cursor: pointer;"/>
                                <img v-else src="/images/battery_gray.png" class="img-responsive center-block" alt="keine Batterie" width=64 height=64 style="-webkit-filter: grayscale(1); cursor: pointer;" title="Lithium Batterie erlauben"/>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end mt-3">
                            <div @click="btnVinyl()" style="margin-top:-10px; margin-left:10px;"> <!--style="margin-top:-48px;"-->
                                <img v-if="(product.flags & VINYL) == VINYL" src="/images/vinyl-icon.png" alt="Vinyl" width=64 height=64 title="Vinyl-Markierung entfernen" style="cursor: pointer;"/>
                                <img v-else src="/images/vinyl-icon-grey.png" class="img-responsive center-block" alt="kein Vinyl" width=64 height=64 style="-webkit-filter: grayscale(1); cursor: pointer;" title="als Vinyl markieren"/>
                            </div>

                        </div>

                        <div v-if="formattedReleaseDate != null && formattedReleaseDate != ''" class="row float-right" style="color: black">
                            ReleaseDate: {{ formattedReleaseDate }}
                        </div>
                        <div v-if="formattedLastSuccessfulMetaDataRequest != null && formattedLastSuccessfulMetaDataRequest != ''" class="row float-right" style="color: black">
                            MD-Anfrage: {{ formattedLastSuccessfulMetaDataRequest }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="px-0">Basisgewicht</td>
                    <td>{{ product.baseWeight }} g</td>
                </tr>
                <tr v-bind:style="{ color: (product.shippingWeightType != SHIPPING_WEIGHT_TYPE_VENDOR ? 'lightgray' : '') }">
                    <td class="px-0">Händler Gewicht</td>
                    <td>{{ product.vendorWeight }} g<span v-if="(product.flags & VENDOR_WEIGHT_AMBIGUOUS) == VENDOR_WEIGHT_AMBIGUOUS"> (Uneindeutig)</span></td>
                    <td><!-- spacer --></td>
                </tr>

                <tr v-if="product.shippingWeightType == 2">
                    <td >Standardgewicht</td>
                    <td v-if="(product.flags & VINYL) == VINYL">400 g</td>
                    <td v-else>200 g</td>
                </tr>

                <tr v-bind:style="{ color: (product.shippingWeightType != SHIPPING_WEIGHT_TYPE_MANUAL ? 'lightgray' : '') }"><td class="px-0" style="white-space: nowrap" >Manuelles Gewicht</td>
                    <td v-if="editWeightState == false" class="d-flex">

                        <div v-if="manualWeightGUI" class="float-left text-nowrap">
                               <!-- {{ product.manualWeight }} g  -->
                               {{ manualWeightGUI }} g
                        </div>
                        
                        <span v-else>Manuelles Gewicht hinzufügen</span>

                        <div class="px-1">
                            <button    type="button" class="btn btn-secondary btn-sm" @click="editWeightState = true;">
                                <span v-if="manualWeightGUI == null" class="icon icon-plus"></span>
                                <span v-else class="icon icon-pencil"></span>
                            </button>
                            <button    v-if="manualWeightGUI != null" type="button" class="btn btn-secondary btn-sm" @click="deleteManualWeight()">
                                <span class="icon icon-bin"></span>
                            </button>
                        
                            <br>
                        </div>
                    </td>
                    <td v-else class="d-flex flex-nowrap">
                        <div class="input-group input-group-sm mb-auto"> 
                            <input type="text" class="form-control" style="min-width: 50px; max-width: 140px" v-model="manualWeightGUI" @keypress.13="saveManualWeight()">
                            <div class="input-group-append mb-auto"><span class="input-group-text">g</span></div>
                        </div>
                            <div class="px-1">
                                <button type="button" class="btn btn-secondary btn-sm" @click="saveManualWeight()">
                                    <span class="icon icon-checkmark"></span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-secondary btn-sm" @click="editWeightState = false;">
                                    <span class="icon icon-cross"></span>
                                </button>
                            </div>
                    </td>
                </tr>
                <tr><td > <!-- spacer --> </td></tr>
                <tr>
                    <td class="px-0">Versandaufschlag Flags</td>
                    <td v-html="computedVersandaufschlagList"></td>
                </tr>
                
                <tr v-bind:style="{color: extraWeightChargeColor}"><td class="px-0">Sonderaufschlag</td>

                    <td v-if="editExtraWeightChargeState == false" class="d-flex">
                        <!-- div v-if="(product.extraWeightCharge != null)" class="float-left">
                                + {{ product.extraWeightCharge }} g 
                        </div -->
                        <div v-if="(extraWeightChargeGUI != null)" class="float-left text-nowrap">
                                + {{ extraWeightChargeGUI}} g  
                        </div>
                        <span v-if="extraWeightChargeGUI == null">Sonderaufschlag hinzufügen</span>

                        <div class="px-1">
                            <button type="button" class="btn btn-secondary btn-sm" @click="editExtraWeightCharge()">
                                <span v-if="extraWeightChargeGUI == null" span class="icon icon-plus"></span>
                                <span v-else span class="icon icon-pencil"></span>
                            </button>
                        </div>

                        <div v-if="extraWeightChargeGUI != null" class="float-left text-nowrap" >
                            <button    type="button" class="btn btn-secondary btn-sm" @click='modalOpenEvent_deleteReason()'>
                                <span class="icon icon-bin"></span>
                            </button>
                        </div>
                    </td>

                    <td v-else class="d-flex flex-nowrap"><!--    EDIT Extra Weight Charge -->

                        <div class="input-group input-group-sm mb-auto"> 
                            <input type="text" class="form-control" style="min-width: 50px; max-width: 140px" v-model="extraWeightChargeGUI" @keypress.13="modalOpenEvent_addReason()">
                            <div class="input-group-append mb-auto"><span class="input-group-text">g</span></div>
                        </div>

                        <div class="pl-1">
                            <button type="button" class="btn btn-secondary btn-sm" @click="modalOpenEvent_addReason()">
                                <span class="icon icon-checkmark"></span>
                            </button>
                        </div>

                        <div class="pl-1">
                            <button type="button" class="btn btn-secondary btn-sm" @click="editExtraWeightChargeState = false">
                                <span class="icon icon-cross"></span>
                            </button>
                        </div>

                    </td>
                </tr>

                <tr><td class="px-0" style="width: 31%;">Kommentar</td>
                    <td>{{product.extraWeightChargeReason}}</td>
                </tr>

                <tr><td class="px-0"><b>Versandgewicht</b></td>
                    <td v-if="product.shippingWeightType == 0"><b>{{ product.shippingWeight }} g (Marktplatz)</b></td>
                    <td v-if="product.shippingWeightType == 1"><b>{{ product.shippingWeight }} g (Händler)</b></td>
                    <td v-if="product.shippingWeightType == 2"><b>{{ product.shippingWeight }} g (Standard)</b></td>
                    <td v-if="product.shippingWeightType == 3"><b>{{ product.shippingWeight }} g (Manuell)</b></td>
                </tr>

                <tr v-if="product.volumeWeight != null">
                    <td class="px-0">Volumengewicht</td>
                    <td>{{ product.volumeWeight }} g</td>
                </tr>

                <tr>
                    <td class="px-0"><b>Sendungsart Flags</b></td>
                    <td colspan="2"><b>{{computedSendungsartList}}</b></td>
                </tr>

                <tr>
                    <td class="px-0">Länge</td>
                    <td v-if="editDimensionsState == true">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control" v-model="product.length" />
                            <div class="input-group-append mb-auto">
                                <span class="input-group-text">cm</span>
                            </div>
                        </div>
                    </td>
                    <td v-else>
                        <div v-if="(product.length != null) && (product.length != 0)"> {{ product.length }} cm</div>
                    </td>
                </tr>
                <tr>
                    <td class="px-0">Breite</td>
                    <td v-if="editDimensionsState == true">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control" v-model="product.width" />
                            <div class="input-group-append mb-auto">
                                <span class="input-group-text">cm</span>
                            </div>
                        </div>
                    </td>
                    <td v-else class="d-flex">
                        <div v-if="(product.width != null) && (product.width != 0)"> {{ product.width }} cm</div>
                        <div class="float-left col-md-2" >
                            <button    type="button" class="btn btn-secondary btn-sm" @click="editDimensions()">
                                <span class="icon icon-pencil"></span>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="px-0">Höhe</td>
                    <td v-if="editDimensionsState == true">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control" v-model="product.height" />
                            <div class="input-group-append mb-auto">
                                <span class="input-group-text">cm</span>
                            </div>
                        </div>
                    </td>
                    <td v-else>
                        <div v-if="(product.height != null) && (product.height != 0)"> {{ product.height }} cm</div>
                    </td>
                </tr>

                <tr v-if="editDimensionsState == true">
                    <td ></td>
                    <td class="d-flex">
                        <div class="pr-1">
                            <button type="button" class="input-group-append btn btn-secondary btn-sm input-sm mb-1" style="padding-top: 5px" @click="saveDimensions()">
                                <span class="icon icon-checkmark"></span>
                            </button>
                        </div>
                    
                        <div>
                            <button type="button" class="input-group-append btn btn-secondary btn-sm" style="padding-top: 5px" @click="editDimensionsState = false">
                                <span class="icon icon-cross"></span>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="px-0">Sonstige Flags</td>
                    <td colspan="2" v-html="computedSonstigeFlagsList"></td>
                </tr>
            </tbody>
        </table>

        <!-- vendor dialogue pop-up menu -->

        <div>
            <b-modal v-model="modalState_addReason" centered 
                @ok="saveExtraWeightCharge(false)"
                ok-title="Bestätigen"
                @cancel="() => {}"
                cancel-title="Abbrechen"
                title="Sonderaufschlag Änderungsgrund"
            ><!-- modal -->
                    <span>Bitte geben Sie einen Grund an, weswegen der Sonderaufschlag abgeändert wird:</span>            
                    <textarea type="text" rows=2 class="form-control" style="resize: none" v-model="product.extraWeightChargeReason"></textarea>
            </b-modal>
        </div>

        <!-- dialogue Sonderaufschl. Delete pop-up menu -->
        <div>
            <b-modal v-model="modalState_deleteReason" centered 
                @ok="modalConfirm_deleteReason()"
                ok-title="Bestätigen"
                @cancel="() => {}"
                cancel-title="Abbrechen"
                title="Sonderaufschlag Änderungsgrund"
            ><!-- modal -->
                    <span>Bitte geben Sie einen Grund an, weswegen der Sonderaufschlag gelöscht wird:</span>            
                    <textarea type="text" rows=2 class="form-control" style="resize: none" v-model="product.extraWeightChargeReason">
                    </textarea>
            </b-modal>
        </div>

        <!-- modal Confirm Dialogue -->
        <div><!-- modal Confirm Dialogue -->
            <b-modal v-model="modalConfirm.state" centered 
                                @ok="modalConfirmDialogueInput('confirm')"
                                ok-title="Bestätigen"
                                @cancel="modalConfirmDialogueInput('abort')"
                                cancel-title="Abbrechen"
                                :title="modalConfirm.title">
                    <p>{{modalConfirm.message}}</p>
            </b-modal>
        </div>

        <modal-error-component v-model="modalError"></modal-error-component>

    </div>
</template>
<script>
    export default {
        props: ['passedProduct', 'passedCurrentUser', 'passedMaterialCategory'],

        data() {
            return {
                product: null,
                isHeavyPackage: null,        // HEAVY_PACKAGE flag
                modalState_addReason:        false,
                modalState_deleteReason:     false,
                formattedReleaseDate:         null,
                manualWeightGUI: null,
                extraWeightChargeGUI: null,  // for displaying in web page 
                extraWeightChargeColor: 'black',
                editExtraWeightChargeState: false, //TODO (20.8.2020) check if this makes sense or not| For some reason this was missing
                editWeightState: false,                         //TODO (20.8.2020) check if this makes sense or not| Maybe deleted by accident.
                editDimensionsState: false,
                modalConfirm:
                {
                    state: false,
                    message: 'pre', //TODO: Why pre??
                    title: 'Bitte bestätigen',
                    callbackFunction: null,
                },
                modalError:
                {
                    show: false,
                    title: 'Speichern',
                    message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.',
                    error: '',
                },
                sonstigeFlagsList: null,
                versandaufschlagList: null,
                sendungsartList: null,
                FSK_18: 1,
                DHL_KLEINPAKET: 2,            //Sendungsart
                BULKY_GOOD: 8,
                AMIIBO: 256,            //Versandaufschlag
                SKYLANDERS: 512,
                FUNKO: 1024,
                KITCHEN: 2048,
                CALENDAR: 4096,
                PARROT: 8192,
                VINYL: 4,                    //Sonstige
                VENDOR_WEIGHT_AMBIGUOUS: 32,
                NINTENDO_GAME: 16384,
                LITHIUM_BATTERY: 32768,
                MANUAL_PACKAGE_DIMENSIONS: 65536,
                POST_NL_LETTERBOX_PLUS:131072,
                CLAIREFONTAINE: 262144,
                TPLINK: 524288,
                MOLESKINE: 1048576,
                NETGEAR: 2097152,
                PALADONE: 4194304,
                OVERSIZED_SPRING: 8388608,
                SHIPPING_WEIGHT_TYPE_MARKET: 0,
                SHIPPING_WEIGHT_TYPE_VENDOR:    1,
                SHIPPING_WEIGHT_TYPE_DEFAULT: 2,
                SHIPPING_WEIGHT_TYPE_MANUAL: 3,
                HEAVY_PACKAGE: 16777216,
                FRAGILE: 33554432,
                DP_LETTER: 67108864,
                DP_WARENPOST_DE: 134217728,
                DP_WARENPOST_INT: 268435456,
                SPRING_LETTER: 536870912,
                SPRING_BOXABLE: 1073741824
            }
        },

        computed: {
            formattedLastSuccessfulMetaDataRequest() {
                if(this.product.lastSuccessfulMetaDataRequest) {
                    return moment(this.product.lastSuccessfulMetaDataRequest).format("DD.MM.YYYY");
                }
                return "-";
            },
            computedSendungsartList: function() {
                let shippingTypeList = [];
                if ((this.product.flags & this.DHL_KLEINPAKET) == this.DHL_KLEINPAKET)               shippingTypeList.push('DHL Kleinpaket');
                if ((this.product.flags & this.BULKY_GOOD) == this.BULKY_GOOD)             shippingTypeList.push('Sperrgut');
                if ((this.product.flags & this.OVERSIZED_SPRING) == this.OVERSIZED_SPRING) shippingTypeList.push('Oversized Spring');
                if ((this.product.flags & this.HEAVY_PACKAGE) == this.HEAVY_PACKAGE)       shippingTypeList.push('Schwerer Karton');

                if ((this.product.flags & this.DP_LETTER) == this.DP_LETTER)               shippingTypeList.push('Brief');
                if ((this.product.flags & this.DP_WARENPOST_DE) == this.DP_WARENPOST_DE)   shippingTypeList.push('Warenpost DE');
                if ((this.product.flags & this.DP_WARENPOST_INT) == this.DP_WARENPOST_INT) shippingTypeList.push('Warenpost Int.');
                if ((this.product.flags & this.SPRING_LETTER) == this.SPRING_LETTER)       shippingTypeList.push('Spring Brief');
                if ((this.product.flags & this.SPRING_BOXABLE) == this.SPRING_BOXABLE)     shippingTypeList.push('Spring Boxable');
                if ((this.product.flags & this.POST_NL_LETTERBOX_PLUS) == this.POST_NL_LETTERBOX_PLUS)  shippingTypeList.push('PostNL Letterbox Plus');


                return _.reduce(shippingTypeList, (sum, x) => { return sum + ((sum == '') ? '' : ', ') + x }, '');
            },
            computedVersandaufschlagList: function() {
                var additionalCostsList = [];
                if ((this.product.flags & this.VINYL) == this.VINYL)              additionalCostsList.push('+ 300 g Vinyl');
                if ((this.product.flags & this.AMIIBO) == this.AMIIBO)            additionalCostsList.push('min. 240 g Amiibo');
                if ((this.product.flags & this.SKYLANDERS) == this.SKYLANDERS)    additionalCostsList.push('min. 240 g Skylanders');
                if ((this.product.flags & this.FUNKO) == this.FUNKO)              additionalCostsList.push('min. 240 g FunKo');
                if (this.product.category == 12)                                  additionalCostsList.push('+ 100 g Küche');
                if (this.product.category == 13)                                  additionalCostsList.push('+ 100 g Office');
                if ((this.product.flags & this.CALENDAR) == this.CALENDAR)        additionalCostsList.push('+ 200 g Kalender');
                if ((this.product.flags & this.PARROT) == this.PARROT)            additionalCostsList.push('+ 150 g Parrot');
                if (this.product.category == 8)                                   additionalCostsList.push('+ 150 g Beauty');
                if ((this.product.flags & this.FRAGILE) == this.FRAGILE)          additionalCostsList.push('+ 200 g zerbrechliche Ware');
                return _.reduce(additionalCostsList, (sum, x) => { return sum + ((sum == '') ? '' : '<br>') + x; }, '');
            },
            computedSonstigeFlagsList: function () {
                var miscFlags = [];
                if ((this.product.flags & this.VENDOR_WEIGHT_AMBIGUOUS)    == this.VENDOR_WEIGHT_AMBIGUOUS)  miscFlags.push('Händler Gewicht uneindeutig');
                if ((this.product.flags & this.NINTENDO_GAME)              == this.NINTENDO_GAME)         miscFlags.push('<b>NINTENDO GAME (Block US/CA/MX)</b>');
                if ((this.product.flags & this.LITHIUM_BATTERY)            == this.LITHIUM_BATTERY)       miscFlags.push('Lithium Batterie');
                if ((this.product.flags & this.CLAIREFONTAINE)             == this.CLAIREFONTAINE)        miscFlags.push('CLAIREFONTAINE (Block US/CA/MX)');
                if ((this.product.flags & this.TPLINK)                     == this.TPLINK)                miscFlags.push('TPLINK (Block)');
                if ((this.product.flags & this.MOLESKINE)                  == this.MOLESKINE)             miscFlags.push('MOLESKINE (Block)');
                if ((this.product.flags & this.NETGEAR)                    == this.NETGEAR)               miscFlags.push('NETGEAR (Block)');
                if ((this.product.flags & this.PALADONE)                   == this.PALADONE)              miscFlags.push('PALADONE (Block)');
                return _.reduce(miscFlags, (sum, x) => { return sum + ((sum == '') ? '' : ', ') + x; }, '');
            }
        },

        methods: {
            modalOpenEvent_addReason()
            {
                this.product.extraWeightChargeReason = '';
                this.modalState_addReason = true;
            },

            modalOpenEvent_deleteReason()
            {
                this.modalState_deleteReason = true;
            },

            modalConfirm_deleteReason()
            {
                //this.extraWeightCharge = null;
                this.product.extraWeightCharge = null;
                this.extraWeightChargeGUI = null;
                this.saveExtraWeightCharge(true);
                this.modalState_deleteReason = false;
            },

            saveExtraWeightChargeReason(isDelete)
            {// when user presses Confirm in modal popup, called by saveExtraWeightCharge()
                //if user wants to delete the extra weight charge, then return true
                if(isDelete) return true;
                //set the setManualWeightUpdateUser flag, so that the user is logged in the metadatabase table (only if a Reason is ever specified).

                this.modalError.error = '';
                if(this.product.extraWeightChargeReason == null || this.product.extraWeightChargeReason == '')
                {
                    this.modalError.message = 'Der Speichervorgang wurde wegen fehlendem Userinput nicht ausgeführt: Es wurde kein Änderungsgrund für den Sonderaufschlag angegeben.';
                    this.modalError.show = true;
                    this.modalState_addReason = false;
                    return false; 
                }

                if( (this.product.extraWeightChargeReason != null) && (this.product.extraWeightChargeReason.toString().length > 30100) )
                {
                    this.modalError.message = 'Achtung: Die Kommentarhistorie des Sonderaufschlags ist für dieses Material größer als 30100 Zeichen angewachsen. Bitte kontaktieren Sie die IT Administration unter Angabe der betroffenen Material ID.';
                    this.modalError.show = true;
                }
                
                if (this.product.extraWeightChargeReason == '' || this.product.extraWeightChargeReason == null)
                {
                    this.product.extraWeightChargeReason = '';
                }
                
                this.modalState_addReason = false;
                return true;
            },

            renderManualWeightUpdateUser()
            {
                this.manualUpdateUser = this.product.manualUpdateHistory;
                var d = new Date(this.forceNumeric(timestamp));
                this.manualUpdateUser = this.currentUser + ' am ' + this.makeDateTimeString(timestamp);
                return 1;
            },
        
            editDimensions()
            {
                this.editDimensionsState = true;
            },

            editExtraWeightCharge()
            {
                this.editExtraWeightChargeState = true;
            },

            deleteManualWeight()
            {
                this.modalConfirmDialogue(
                    'Wollen Sie das manuelle Gewicht wirklich löschen?',
                    () => {
                        this.manualWeightGUI = null;
                        this.product.manualWeight = null;
                        this.save();
                    }
                );
            },

            deleteExtraWeightCharge()
            {
                this.modalConfirmDialogue('Wollen Sie den Sonderaufschlag wirklich löschen?',
                    (() => {
                        this.product.extraWeightCharge = null;
                        this.extraWeightChargeGUI = null;
                        //this.extraWeightCharge = null;
                        this.modalOpenEvent_addReason();
                    })
                );
            },

            saveManualWeight()
            {
                //if(this.forceNumeric(isNaN(this.manualWeightGUI)))
                if(isNaN(this.forceNumeric(this.manualWeightGUI)))
                {
                    this.modalError.title = 'manuelles Gewicht';
                    this.modalError.message = "Vorgang abgebrochen: Manuelles Gewicht muss eine Zahl sein.";
                    this.modalError.show = true;    
                }
                else
                {
                    this.product.manualWeight = this.forceNumeric(this.manualWeightGUI);
                    this.editWeightState = false;
                    try 
                    {
                        this.save();
                    }
                    catch(error)
                    {
                        console.log(error);
                        this.modalError.error = error.toString();
                        this.modalError.message = "Speichervorgang wurde aufgrund eines serverseitigen Fehlers nicht ausgeführt.";
                        this.modalError.show = true;
                        
                        this.product.setManualWeightUpdateUser = '0';
                    }
                }
            },

            saveExtraWeightCharge(isDelete)
            {
                try
                {
                  if(isNaN(this.forceNumeric(this.extraWeightChargeGUI)) && !isDelete)
                  {
                    throw "Gewicht muss eine Zahl sein.";
                  }

                    this.product.extraWeightCharge = ( this.extraWeightChargeGUI == null ) ? null : this.forceNumeric(this.extraWeightChargeGUI);

                    this.editExtraWeightChargeState = false;
                    if(!this.saveExtraWeightChargeReason(isDelete)) {
                        throw "Kein Sonderaufschlagsgrund angegeben.";
                    }
                }
                catch(error)
                {
                    console.log(error);
                    this.modalError.error = error.toString();
                    this.modalError.message = "Der Speichervorgang wurde aufgrund eines serverseitigen Fehlers nicht ausgeführt.";
                    this.modalError.show = true;
                    this.product.setManualWeightUpdateUser = '0';
                }
            
                this.save();
            },

            saveDimensions()
            {
                try
                {
                    if( !this.sanityCheckMaybeInt(this.product.length) ||    !this.sanityCheckMaybeInt(this.product.width)
                    || !this.sanityCheckMaybeInt(this.product.height))
                    {
                        this.modalError.error = '';
                        this.modalError.message = "Der Speichervorgang wurde wegen fehelrhaftem Userinput nicht ausgeführt: Die Paketmaße müssen ganzzahlig sein.";
                        this.modalError.show = true;
                        return false;
                    }

                    if(this.product.length == null || this.product.length == '' 
                    || this.product.width == null    || this.product.width == '' 
                    || this.product.height == null || this.product.height == '')
                    {
                        this.modalError.error = '';
                        this.modalError.message = "Der Speichervorgang wurde wegen fehlendem Userinput nicht ausgeführt: Um abspeichern zu können, müssen Länge, Breite und Höhe angegeben werden (in den Feldern -Höhe, Breite, Länge- müssen ganze Zahlen stehen).";
                        this.modalError.show = true;
                        return false;
                    }
                    ['length', 'width', 'height'].forEach( dim => { this.product[dim] = Number.parseInt(this.product[dim]) });
                    // this.product.length = this.product.length; //wtf
                    // this.product.width = this.product.width;
                    // this.product.height = this.product.height;
                    this.editDimensionsState = false;
                    this.product.flags |= this.MANUAL_PACKAGE_DIMENSIONS;
                    this.save();
                }
                catch(error)
                {
                    if(error != null)
                    {
                        console.log(error);
                        this.modalError.error = error.toString();
                    }
                    this.modalError.message = "Der Speichervorgang wurde aufgrund eines serverseitigen Fehlers nicht ausgeführt.";
                    this.modalError.show = true;
                    this.product.setManualWeightUpdateUser = '0';
                }
                return true;
            },
            save()
            {
                //this.product.materialCategory = this.passedMaterialCategory;
                this.product.manualUpdateOverride = true;
                axios.put('/mds/product', this.product)
                .then( response => {
                    this.product = response.data;
                    this.formatReleaseDate();
                }).catch( error => {
                    this.modalError = {
                        show: true,
                        title: 'Speichern',
                        message: "Der Speichervorgang konnte aufgrund eines serverseitigen Fehlers nicht ausgeführt werden.",
                        error: error.toString()
                    };
                    this.product.setManualWeightUpdateUser = '0';
                    axios.get(`/mds/product/${this.product.asin}`).then( response => {
                        this.product = response.data;
                    }).catch( error => console.log(error) );
                });
            },
            chkHeavyPackage()
            {
                if(this.isHeavyPackage)
                {
                    this.product.flags += this.HEAVY_PACKAGE;
                }
                else
                {
                    this.product.flags -= this.HEAVY_PACKAGE;
                }
                this.product.flagOverrides |= this.HEAVY_PACKAGE;
                this.save();
            },
            btnFsk()
            {
                if ((this.product.flags & this.FSK_18) == this.FSK_18)
                {
                    this.modalConfirmDialogue(
                        "Wollen Sie die FSK 18 Markierung entfernen?",
                        (() => {
                            this.product.flags -= this.FSK_18;
                            this.product.flagOverrides |= this.FSK_18;
                            this.save();
                        })
                    );
                }
                else
                {
                    this.modalConfirmDialogue(
                        "Wollen Sie das Material als FSK 18 markieren?",
                        (() => {
                            this.product.flags += this.FSK_18; //This i ok 
                            this.product.flagOverrides |= this.FSK_18;
                            this.save();
                        })
                    );
                }

            },
            btnLithium() 
            {
                if ((this.product.flags & this.LITHIUM_BATTERY) == this.LITHIUM_BATTERY)
                {
                    this.modalConfirmDialogue(
                        "Wollen Sie die Batterie Markierung entfernen?",
                        (() => {
                            this.product.flags -= this.LITHIUM_BATTERY;
                            this.product.flagOverrides |= this.LITHIUM_BATTERY;
                            this.save();
                        })
                    );
                }
                else
                {
                    this.modalConfirmDialogue(
                        "Wollen Sie die Batterie Markierung hinzufügen?",
                        (() => {
                            this.product.flags += this.LITHIUM_BATTERY;
                            this.product.flagOverrides |= this.LITHIUM_BATTERY;
                            this.save();
                        })
                    );
                }
            },
            btnVinyl()
            {
                if ((this.product.flags & this.VINYL) == this.VINYL)
                {
                    this.modalConfirmDialogue(
                        "Wollen Sie die Vinyl Markierung entfernen?",
                        (() => {
                          this.product.flags -= this.VINYL;
                          this.product.flagOverrides |= this.VINYL;
                          this.save();
                        })
                    );
                }
                else
                {
                  this.modalConfirmDialogue(
                      "Wollen Sie die Vinyl Markierung hinzufügen?",
                      (() => {
                        this.product.flags += this.VINYL;
                        this.product.flagOverrides |= this.VINYL;
                        this.save();
                      })
                  );
                }
            },
            setExtraWeightChargeColor()
            {
                if(this.product.extraWeightCharge == null)
                {
                    this.extraWeightChargeColor = 'lightgray';
                }
                else
                {
                    this.extraWeightChargeColor = 'black';
                }
            },
            
            forceNumeric(maybeNumeric)
            {
                if(maybeNumeric == null) return null;
                return Number(maybeNumeric.toString().replace(',','.'));
            },
            
            sanityCheckMaybeInt(x)
            {    
                if (typeof x == 'number') {
                    return Number.isInteger(x);
                }
                for (var k = 0; k < x.length; k++) {
                    if(isNaN(x.charAt(k)))
                    {
                        return false;    
                    }
                }
                return true;
            },

            formatReleaseDate()
            {
                //"Because of the variances in parsing of date strings, it is recommended to always manually parse strings as results are inconsistent, ..."
                // assumes format: YYYY-MM-DD
            
                if (this.product.releaseDate === null || this.product.releaseDate === "") return;

                var year = this.product.releaseDate.substr(0,4);
                var month = this.product.releaseDate.substr(5,2);
                var day = this.product.releaseDate.substr(8,2);
                this.formattedReleaseDate = day + '.' + month + '.' + year;
            },

            makeDateTimeString(timestamp)
            {
                var dt = new Date(this.forceNumeric(timestamp));
                var month     = Number(dt.getMonth() + 1);
                var day       = Number(dt.getDate());
                var hours     = Number(dt.getHours());
                var minutes   = Number(dt.getMinutes());
                var seconds   = Number(dt.getSeconds());

                month   = (month     > 9) ? month     : '0' +    month.toString();
                day     = (day         > 9) ? day         : '0' +    day.toString();
                hours   = (hours     > 9) ? hours     : '0' +    hours.toString();
                minutes = (minutes     > 9) ? minutes     : '0' +    minutes.toString();
                seconds = (seconds     > 9) ? seconds     : '0' +    seconds.toString();
    
                return        day
                    + '.' + month
                    + '.' + dt.getFullYear()
                    + ', '+ hours
                    + ':' + minutes 
                    + ':' + seconds;
            },

            modalConfirmDialogue(message, func)
            {
                this.modalConfirm.state = true;
                this.modalConfirm.message = message;
                this.modalConfirm.callbackFunction = func;
            },

            modalConfirmDialogueInput(choice)
            {
                if(choice == 'confirm')
                {
                    this.modalConfirm.callbackFunction.call();
                }
                else if (choice != 'abort')
                {
                    alert('modalConfirmDialogueInput: unknown input: ' + choice);
                }

                //probably would work best as functor
                this.modalConfirm.state = false;
                this.modalConfirm.message = null;
                this.modalConfirm.callbackFunction = null;

            }
        },

        mounted()
        {
            this.product = this.passedProduct;
            this.extraWeightChargeGUI= this.product.extraWeightCharge;
            this.manualWeightGUI = this.product.manualWeight;

            //compute heavy_package flag state;

            if( (this.product.flags & this.HEAVY_PACKAGE) === this.HEAVY_PACKAGE )
            {   
                this.isHeavyPackage = ((this.product.flags & this.HEAVY_PACKAGE) === this.HEAVY_PACKAGE );
            }

            //this.lastUpdateTime = this.makeDateTimeString(timestamp);
            this.lastUpdateTime = null;
            this.formatReleaseDate();
            axios.get(`/mds/product/${this.product.asin}`).then( response => {
                this.product = response.data;
            }).catch( error => {
                console.log(error);
                alert(JSON.stringify(error));
            });
        }
    }
</script>t>